import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { API_QUERY_KEYS, getAllParentOrganisations, QueryDefaults } from 'api';
import { GetAllParentOrganisationsResponse } from 'types';

export const useAllParentOrganisations =
  (): UseQueryResult<GetAllParentOrganisationsResponse> => {
    return useQuery(
      [API_QUERY_KEYS.getAllParentOrganisations],
      () => getAllParentOrganisations(),
      {
        ...QueryDefaults,
      }
    );
  };
